module.exports = __webpack_public_path__ + "static/WhatsApp-0e878a0fa68c61b06e781cee2e6bc71f.svg";